const getNombresManfiestosUnicos = (items) => {
    const itemsManifiestosNombres = items.map(item=>item.manifiesto)
    const nombresManfiestosUnicos = new Set(itemsManifiestosNombres)
    return [...nombresManfiestosUnicos]
}

export default getNombresManfiestosUnicos